import React from "react";

const HashtagsSection = ({ author, hashtags }) => {
  // Only show if hashtags length > 0
  if (!hashtags || hashtags.length === 0) {
    return null;
  }

  return (
    <div className="px-4 pb-3">
      <div className="flex flex-wrap gap-2">
        {/* Username */}
        {author && (
          <span className="font-semibold text-gray-900 text-sm">
            {author}
          </span>
        )}

        {/* Hashtags */}
        {hashtags && hashtags.length > 0 && (
          <>
            {hashtags.map((tag, index) => (
              <span
                key={index}
                className="text-sm text-blue-600 whitespace-nowrap"
              >
                {tag.startsWith("#") ? tag : `#${tag}`}
              </span>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default HashtagsSection;